<!-- EM_MO_SB_007  카드 상세내역 -->
<template>
  <div class="card-detail-wrap">
    <div class="card-detail-top">
      <img :src="prepaidCardInfo.imageUrl" alt="">
      <div>
        <em>
          {{ Number(prepaidCardInfo.remainCash).toLocaleString() }}<button v-if="prepaidCardInfo.representative && prepaidCardInfo.status === 'ACTIVATION'" class="icon-star"></button>
          <button v-else-if="!prepaidCardInfo.representative && prepaidCardInfo.status === 'ACTIVATION'" class="icon-star-gray" @click="toggleChangeRepresentativePopup(prepaidCardInfo)"></button>
        </em>
        <strong>{{ prepaidCardInfo.prepaidCardNickName != null? prepaidCardInfo.prepaidCardNickName : prepaidCardInfo.giftMessage != null? prepaidCardInfo.giftMessage : '' }}</strong>
        <span v-if="prepaidCardInfo.expirationEndDate">유효기간<small>~ {{ prepaidCardInfo.expirationEndDate }}</small></span>
        <span v-else>유효기간<small>없음</small></span>
      </div>
    </div>
    <keyboard
      v-if="showKeyboard"
      @enterEmarticonPassword="enterEmarticonPassword"
      :certifiedRequestCount="certifiedRequestCount"
      :certifiedRestriction="emarticonMberPwdPolicy.certifiedRestriction"
      :certifiedRestrictionCount="emarticonMberPwdPolicy.certifiedRestrictionCount"
      :barcodeNo='prepaidCardInfo.prepaidCardNo'
      :showKeyboard='showKeyboard'
      @closeKeyboard="closeKeyboard"
      @closeKeyboardBio="closeKeyboardBio"
    />
    <button class="barcode-box" v-if="!showBarcode" @click="getEmarticonMberPassword">
      <p class="barcode">
        <img v-if="!showBarcode" src="@/assets/images/cards/card-detail-barcode-disabled.png" alt="바코드" />
      </p>
      <div v-if="!showBarcode">
          <span> 비밀번호 입력 후 결제 해주세요 ></span>
      </div>
    </button>

    <div class="barcode-box" v-if="showBarcode">
      <vue-barcode v-if="showBarcode" v-model="prepaidCardInfo.prepaidCardNo" tag="img" displayValue="false" height="35" width="2" elementTag="img" style="text-align: center; display: flex; flex-direction: column; align-content: space-around">
        Show this if the rendering fails.
      </vue-barcode>
      <div v-if="showBarcode">
        <div v-if="prepaidCardInfo.status === 'ACTIVATION'">
          <span>{{ prepaidCardInfo.prepaidCardNo }}</span>
          <em>사용가능</em>
        </div>
        <div v-else-if="prepaidCardInfo.status === 'LOCKED'">
          <span>{{ prepaidCardInfo.prepaidCardNo }}</span>
          <em class="color-red">사용중지</em>
        </div>
<!--        <div v-else-if="prepaidCardNo.substr(0, 6) == '321198' && prepaidCardInfo.status === 'EXPIRATION'">-->
        <div v-else-if="prepaidCardInfo.goodsName == '신세계 유니버스 클럽' && prepaidCardInfo.status === 'EXPIRATION'">
          <span>사용 불가능(유니버스 클럽 기간 종료)</span>
          <em></em>
        </div>
      </div>
    </div>
    <div class="card-button-wrap">
      <div class="button-wrap button-style card-button">
        <button
          :class="prepaidCardInfo.status==='ACTIVATION' && prepaidCardInfo.reload?'button-bg-yellow round':'button-disabled'"
          @click="$router.push({name:'reloadCash', params:{cardInfo:prepaidCardInfo}})"
          :disabled="prepaidCardInfo.status!=='ACTIVATION' || !prepaidCardInfo.reload">충전하기</button>
      </div>
      <div class="button-wrap button-style card-button">
        <button
          :class="prepaidCardInfo.status === 'ACTIVATION' && prepaidCardInfo.autoReload?'button-bg-gray round':'button-disabled'"
          @click="$router.push({name:'charging', params:{cardInfo:prepaidCardInfo}})"
          :disabled="prepaidCardInfo.status!=='ACTIVATION' || !prepaidCardInfo.autoReload">자동 충전 설정</button>
      </div>
    </div>
    <div v-if="prepaidCardInfo.status === 'LOCKED'" class="stop-box">
      <span>사용 중지된 카드입니다.</span>
      <button @click="$router.push({name:'stopUsingCancel', params:{cardInfo:prepaidCardInfo}})">취소하기</button>
    </div>
    <gray-line class="absolute"></gray-line>
    <div class="card-detail-list">
      <div class="card-list-text-box">
        <span>최근 이용 내역 {{ cardRedeemDetails.length }}건</span>
        <button @click="$router.push({name:'usageDetail', params:{prepaidCardNo:prepaidCardInfo.prepaidCardNo}})">전체보기</button>
      </div>
      <!-- 이용 내역 컴포넌트 불러오기 -->
      <use-history :list-data="cardRedeemDetails"></use-history>
    </div>
    <gray-line class="absolute"></gray-line>
    <div class="card-detail-list">
      <div class="card-list-text-box">
        <span>충전내역</span>
      </div>
      <use-history :list-data="cardReloadDetails"></use-history>
    </div>
    <gray-line class="absolute"></gray-line>
    <div class="card-notice-wrap">
      <ul>
<!--        <li v-if="prepaidCardInfo.prepaidCardNo && prepaidCardInfo.prepaidCardNo.substr(0, 6) != '321198'" :class="prepaidCardInfo.status === 'ACTIVATION'? 'notice-box-item' : 'notice-box-item opacity'" :tabindex="prepaidCardInfo.status === 'ACTIVATION'? '0' : null" @click="moveToStopUsing()">-->
        <li v-if="prepaidCardInfo.prepaidCardNo && prepaidCardInfo.goodsName != '신세계 유니버스 클럽'" :class="prepaidCardInfo.status === 'ACTIVATION'? 'notice-box-item' : 'notice-box-item opacity'" :tabindex="prepaidCardInfo.status === 'ACTIVATION'? '0' : null" @click="moveToStopUsing()">
          <div class="notice-item-left">
            <span class='icon-stop'></span>
            <span class="notice-item-text">사용중지 신청</span>
          </div>
          <span class='icon-chevron-right'></span>
        </li>
        <li class='notice-box-item' v-if="!paymentVoidable && prepaidCardInfo.goodsType !== 'B2B' && prepaidCardInfo.goodsName != '증정 이마티콘(APP)' && prepaidCardInfo.goodsName != '증정 이마티콘(MMS)'"
            tabindex='0' @click="$router.push({name: 'refund', params: { cardInfo: prepaidCardInfo }})" >
          <div class="notice-item-left">
            <span class='icon-return'></span>
            <span class="notice-item-text">환불하기</span>
          </div>
        </li>
        <li class='notice-box-item' v-if="paymentVoidable && prepaidCardInfo.goodsType !== 'B2B'" tabindex='0' @click="$router.push({ name: 'paymentVoid', params: { cardInfo: prepaidCardInfo } })">
          <div class="notice-item-left">
            <span class='icon-stop'></span>
            <span class="notice-item-text">구매취소</span>
          </div>
        </li>
        <li class='notice-box-item' tabindex='0' @click="$router.push({ name: 'emarticonQuestions' })">
          <div class="notice-item-left">
            <span class='icon-question'></span>
            <span class="notice-item-text">자주하는 질문</span>
          </div>
          <span class='icon-chevron-right'></span>
        </li>
      </ul>
    </div>
    <change-representative-popup v-if="showChangeRepresentativePopup" :card-name="cardName" v-on:toggleChangeRepresentativePopup="toggleChangeRepresentativePopup" v-on:changeRepresentativeCard="changeRepresentativeCard" />
    <password-alert-popup v-if="showPasswordPopup === true" @confirmPopupClickConfirm="$confirmPopupClickConfirm" :message="alertMessage" />
    <password-alert-popup v-if="showError === true" @confirmPopupClickConfirm="showError = false" :message="alertMessage" />
    <password-confirm-popup v-if="showConfirmPopup === true" @confirmPopupClickNo="$confirmPopupClickNo" @confirmPopupClickYes="$confirmPopupClickConfirm" :message="alertMessage" :confirmPopupNoButton="confirmPopupNoButton" :confirmPopupYesButton="confirmPopupYesButton" />
  </div>
</template>

<script>
import GrayLine from '@/components/common/GrayLine.vue';
import UseHistory from '@/components/common/UseHistory.vue';
import VueBarcode from 'vue-barcode';
import apiList from '@/api/apiList';
import ChangeRepresentativePopup from '@/views/myemarticon/changeRepresentativePopup';
import Keyboard from '@/components/common/Keyboard.vue';
import certMixin from '@/plugins/certMixin';
import PasswordAlertPopup from '@/views/myemarticon/passwordAlertPopup.vue';
import PasswordConfirmPopup from '@/views/myemarticon/passwordConfirmPopup.vue';
import commonScripts from '@/plugins/commonScripts';
import dayjs from "dayjs";

export default {
  name: 'CardDetail',
  components: { PasswordConfirmPopup, PasswordAlertPopup, GrayLine, UseHistory, VueBarcode, ChangeRepresentativePopup, Keyboard },
  mixins: [certMixin],
  props: {
    prepaidCardNo: {
      type: String
    }
  },
  data() {
    return {
      cardRedeemDetails : [],
      cardReloadDetails : [],
      paymentVoidable: true,
      prepaidCardInfo: {
        remainCash: 0
      },
      showChangeRepresentativePopup: false,
      cardName: '',
      showAlertPopup: false,
      showPasswordPopup: false,
      showError: false,
      showConfirmPopup: false,
      confirmPopupNoButton: '',
      confirmPopupYesButton: '',
      alertMessage: '',
      showBarcode: false,
      showKeyboard: false,
      isAppUpdatedNeeded: false,
      certifiedRequestCount: '',
      emarticonMberPwdPolicy: {
        ctmmnyNo: '',
        certified: false,
        passwordForce: false,
        certifiedRestriction: false,
        certifiedRestrictionCount: null,
      },
      emarticonMberPwdRequest: {
        certifiedType: 'PASSWORD',
        emarticonPassword: '',
        prepaidCardNo: this.prepaidCardNo,
      },
    };
  },
  async mounted() {
    this.$heading('이마티콘 상세');

    if(this.prepaidCardNo !== null && this.prepaidCardNo !== undefined && this.prepaidCardNo !== '') {
      this.$store.commit("setPrepaidCardNo", this.prepaidCardNo);
    }
    await this.getAdminMberPwdPolicy();
    await this.getPrepaidCardBox();
    await this.getPrepaidCardRedeemDetail();
    await this.getPrepaidCardReloadDetail();
    await this.toggleBarcodePopup();
  },
  watch: {
    overflowVal(newValue, oldValue) {
      if(newValue) {
        // 마우스 스크롤 막기
        document.body.style.overflow = 'hidden'
      } else {
        // 마우스 스크롤 해제
        document.body.style.overflow = 'auto'
      }
    },
  },
  computed: {
    overflowVal() {
      return this.showPasswordPopup || this.showError || this.showConfirmPopup || this.showKeyboard;
    },
  },
  methods: {
    async getPrepaidCardBox() {
      try {
        const res = await apiList.getPrePaidCardBox({size: '1', pageNo: '1', prepaidCardNo: this.$store.state.prepaidCardNo});
        this.prepaidCardInfo = res.data.data.list[0];
        if(this.prepaidCardInfo.status === 'DISCARD' || (this.prepaidCardInfo.status === 'LOCKED' && this.prepaidCardInfo.refundStatus)) {
          await this.$router.replace({name: 'saveBox'});
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getPrepaidCardRedeemDetail() {
      try{
        const param = {
          size: 3,
          pageNo: 1,
          prepaidCardNo: this.$store.state.prepaidCardNo
        }
        const response = await apiList.getPrepaidRedeemDetail(param);
        let redeemDetails = response.data.data.redeemDetails.list;
        for(let i=0; i<redeemDetails.length; i++) {

          let text = "";

          if(redeemDetails[i].purchaseCode === "REFUND") {
            text = "환불";
          } else if(redeemDetails[i].purchaseCode === "EXPIRATION") {
            text = "만료";
          }else if(redeemDetails[i].voided){
            text = redeemDetails[i].merchantName+"[사용취소]";
          } else if(!redeemDetails[i].voided) {
            // eslint-disable-next-line no-unused-vars
            text = redeemDetails[i].merchantName;
          }

          this.cardRedeemDetails.push({
            text: text,
            firstDate: redeemDetails[i].transactionDateTime ,
            price: redeemDetails[i].voided?'+'+redeemDetails[i].redemptionCash:'-'+redeemDetails[i].redemptionCash
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getPrepaidCardReloadDetail() {
      try{
        const res = await apiList.getPrepaidReloadDetailList({prepaidCardNo:this.$store.state.prepaidCardNo});
        this.paymentVoidable = res.data.data.paymentVoidable;
        let reloadDetails = res.data.data.reloadDetails;
        reloadDetails.forEach((el) => {
          if(el.cashCode === 'PROMOTIONCASH') { //증정상품권 전용 충전 리스트
            this.cardReloadDetails.push({
              text: el.promotionalEventName + '(' + el.merchantName + ')',
              firstDate: dayjs(el.transactionDateTime).format('YYYY/MM/DD'),
              lastDate: dayjs(el.transactionDateTime).format('HH:mm'),
              price: el.paymentReason === 'RELOAD_VOID'?'-'+el.cashAmount:'+'+el.cashAmount,
              color: el.paymentReason === 'RELOAD_VOID'?null:'color-blue'
            });
          } else {
            this.cardReloadDetails.push({
              text: el.voided?el.paymentReasonName+'[충전취소]':el.paymentReasonName,
              firstDate: dayjs(el.transactionDateTime).format('YYYY/MM/DD'),
              lastDate: dayjs(el.transactionDateTime).format('HH:mm'),
              price: el.voided?'-'+el.cashAmount:'+'+el.cashAmount,
              color: el.voided?null:'color-blue'
            });
          }
        })
      } catch (error) {
        console.error(error);
      }
    },
    moveToStopUsing() {
      if(this.prepaidCardInfo.status === 'ACTIVATION') {
        this.$router.push({name:'stopUsing', params:{cardInfo:this.prepaidCardInfo}})
      }
    },
    /**
     * 관리자 비밀번호 정책 조회
     */
    async getAdminMberPwdPolicy() {
      const adminRes = await apiList.getAdminMberPwdPolicy({ ctmmnyNo: this.$store.state.partnerId });
      this.emarticonMberPwdPolicy = adminRes.data.data;
      if (!this.emarticonMberPwdPolicy.certified) {
        this.$store.commit('setIsMberPwdAuthenticated');
      }
      if(this.$store.state.nativeStore.isApp) {
        this.setIsEmarticonPasswordEnabled();
      }
    },
    /**
     * 대표카드 변경 팝업 노출
     */
    toggleChangeRepresentativePopup(cardInfo) {
      this.showChangeRepresentativePopup = !this.showChangeRepresentativePopup;
      this.cardName = cardInfo.prepaidCardNickName != null? cardInfo.prepaidCardNickName : cardInfo.giftMessage != null? cardInfo.giftMessage : '이마티콘 카드' //TODO 기본카드명??
    },
    /**
     * 대표카드 변경 API 호출
     */
    async changeRepresentativeCard() {
      try{
        await apiList.putRepresentativeCard({prepaidCardNo: this.prepaidCardNo});
        this.showChangeRepresentativePopup = false;
        this.prepaidCardInfo.representative = true;
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 이마티콘 회원 비밀번호 설정 조회
     */
    async toggleBarcodePopup() {
      if(this.$store.state.isMberPwdAuthPass) {
        await this.decryptPrepaidCardNo();
      }
      this.showBarcode = !(this.emarticonMberPwdPolicy.certified && !this.$store.state.isMberPwdAuthenticated && !this.$store.state.isMberPwdAuthPass);
    },
    /**
     * 이마티콘 회원 비밀번호 검증 API 호출
     */
    async getEmarticonMberPassword() {
      if (this.isAppUpdatedNeeded) {
        this.alertMessage = '새로운 기능을 이용하기 위해<br> 앱을 최신 버전으로 업데이트해 주세요.';
        this.confirmPopupYesButton = '업데이트';
        this.confirmPopupNoButton = '닫기';
        this.showConfirmPopup = true;
        return;
      }

      // 비밀번호 설정 여부 조회
      try {
        this.emarticonMberPwdRequest.certifiedType = 'PASSWORD';
        this.emarticonMberPwdRequest.prepaidCardNo = this.prepaidCardInfo.prepaidCardNo;
        const res = await apiList.postCheckMberPassword(this.emarticonMberPwdRequest);
        if (res.code === 'no.member.password.was.found') {
          if (!this.$store.state.isMberPwdAuthPass) {
            if (this.emarticonMberPwdPolicy.passwordForce) {
              this.alertMessage = '최초 1회 비밀번호 설정이 필요합니다.<br>비밀번호 설정으로 이동합니다.';
              this.showPasswordPopup = true;
            } else {
              this.confirmPopupNoButton = '닫기';
              this.confirmPopupYesButton = '비밀번호 설정';

              const today = new Date();
              const changeDate = new Date('2025-04-01T00:00:00');
              if(today >= changeDate) {
                this.alertMessage = '최초 1회 비밀번호 설정이 필요합니다.<br>비밀번호 설정으로 이동하시겠습니까?';
              } else {
                this.alertMessage = '4월 1일부터는 사용을 위한<br> 비밀번호 설정이 필수입니다.<br> 편리한 사용을 위해서 미리 설정해 주세요.';
              }
              this.showConfirmPopup = true;
            }
          }
        } else if(res.code === 'this.password.has.exceeded.the.maximum.number.of.certified.restriction.count') {
          this.alertMessage = `비밀번호를 <em>${res.message}회</em> 잘못 입력하셨습니다.<br>비밀번호 설정 화면으로 이동합니다.`;
          this.showPasswordPopup = true;
        } else {
          this.certifiedRequestCount = res.data.data.certifiedRequestCount;
          this.showKeyboard = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * Confirm 팝업 예 클릭
     */
    $confirmPopupClickConfirm() {
      if (this.alertMessage === '새로운 기능을 이용하기 위해<br> 앱을 최신 버전으로 업데이트해 주세요.') {
        const device = this.$store.state.nativeStore.device;
        if (device === 'and') {
          // 안드로이드일 경우
          let iframe = document.createElement('iframe');
          iframe.style.visibility = 'hidden';
          iframe.src = 'market://details?id=com.emart.today';
          document.body.appendChild(iframe);
          document.body.removeChild(iframe);
        } else if (device === 'ios') {
          // 아이폰일 경우
          location.replace('http://itunes.apple.com/kr/app/id397728319?mt=8');
        }
        this.showConfirmPopup = false;
      } else {
        this.showPasswordPopup = false;
        this.$router.push({ name: 'setting' });
      }
    },
    /**
     * 이마티콘 회원 비밀번호 설정 팝업 아니오 클릭
     */
    async $confirmPopupClickNo() {
      if (this.alertMessage === '새로운 기능을 이용하기 위해<br> 앱을 최신 버전으로 업데이트해 주세요.') {
        this.showConfirmPopup = false;
      } else {
        await this.decryptPrepaidCardNo();
        this.showConfirmPopup = false;
        this.showBarcode = !this.showBarcode;
        this.$store.commit('setIsMberPwdAuthenticated');
      }
    },
    /**
     * 이마티콘 회원 비밀번호 입력
     */
    enterEmarticonPassword(password) {
      this.emarticonMberPwdRequest.emarticonPassword = password;
      this.checkEmarticonMberPassword();
    },

    /**
     * 이마티콘 회원 비밀번호 강제 미사용 닫기 처리
     */
    async closeKeyboard() {
      this.emarticonMberPwdRequest.emarticonPassword = '';
      if (!this.emarticonMberPwdPolicy.passwordForce) {
        this.$store.commit('setIsMberPwdAuthenticated');
        await this.decryptPrepaidCardNo();
        this.showBarcode = true;
      }

      this.showKeyboard = false;
    },

    /**
     * 이마티콘 회원 비밀번호 생체인증 성공 닫기 처리
     */
    async closeKeyboardBio() {
      this.emarticonMberPwdRequest.certifiedType = 'BIO';
      await apiList.postCheckMberPassword(this.emarticonMberPwdRequest);
      await this.decryptPrepaidCardNo();
      this.$store.commit('setIsMberPwdAuthenticated');
      this.showKeyboard = false;
      this.showBarcode = true;
    },

    /**
     * 이마티콘 회원 비밀번호 검증 API 호출
     */
    async checkEmarticonMberPassword() {
      try {
        this.emarticonMberPwdRequest.certifiedType = 'PASSWORD';
        const res = await apiList.postCheckMberPassword(this.emarticonMberPwdRequest);
        if (res.code === 'this.password.has.exceeded.the.maximum.number.of.certified.restriction.count') {
          this.alertMessage = `비밀번호를 <em>${this.emarticonMberPwdPolicy.certifiedRestrictionCount}회</em> 잘못 입력하셨습니다. <br> 비밀번호 설정으로 이동합니다.`;
          this.showKeyboard = false;
          this.showPasswordPopup = true;
        } else if (res.code === 'this.password.does.not.match') {
          if(this.emarticonMberPwdPolicy.certifiedRestriction) {
            this.certifiedRequestCount = res.message;
            this.alertMessage = `비밀번호를 <em>${res.message}회</em> 잘못 입력하셨습니다. <br> <em>${this.emarticonMberPwdPolicy.certifiedRestrictionCount}회</em> 오류 시 재설정이 필요합니다.`;
            this.showError = true;
          } else {
            this.certifiedRequestCount = null;
            this.alertMessage = `비밀번호를 잘못 입력하셨습니다.<br>비밀번호를 확인해 주세요.`;
            this.showError = true;
          }
        } else if (res.data.code === 'S00000') {
          // 모의해킹 조치 password 입력 없이도 성공 응답을 내려주고 있어 password 입력 건에 대해 별도 처리
          if(res.data.data.emarticonPassword === 'true') {
            this.showKeyboard = false;
            this.$store.commit('setIsMberPwdAuthenticated');
            await this.decryptPrepaidCardNo();
            this.showBarcode = true;
          } else {
            this.certifiedRequestCount = null;
            this.alertMessage = `비밀번호를 잘못 입력하셨습니다.<br>비밀번호를 확인해 주세요.`;
            this.showError = true;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async decryptPrepaidCardNo() {
      const decryptRes = await apiList.getPrepaidCardDecrypt({ prepaidCardNo: this.$store.state.prepaidCardNo });
      this.prepaidCardInfo.prepaidCardNo = decryptRes.data.toString();
      this.prepaidCardNo = decryptRes.data.toString();
      this.$store.commit('setPrepaidCardNo', decryptRes.data.toString());
    },
    /**
     * 기간별 이마티콘 비밀번호 사용여부 설정
     */
    setIsEmarticonPasswordEnabled() {
      const device = this.$store.state.nativeStore.device;
      const appVer = this.$store.state.nativeStore.appVer;
      const today = new Date();

      const firstBeginDate = new Date('2025-01-21T00:00:00');
      const secondBeginDate = new Date('2025-02-17T00:00:00');
      const thirdBeginDate = new Date('2025-04-01T00:00:00');

      let isNewVersion;
      if (device === 'and') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.1.2');
      } else if (device === 'ios') {
        isNewVersion = commonScripts.$compareVersions(appVer, '5.0.9');
      }

      if (today < firstBeginDate) {
        this.isAppUpdatedNeeded = false;
      } else if (today >= firstBeginDate && today < secondBeginDate) {
        // 구버전: 비번/생체 사용 x
        // 신버전: 비번/생체 사용 가능
        if (!isNewVersion) {
          this.emarticonMberPwdPolicy.certified = false;
          this.$store.commit('setIsMberPwdAuthenticated');
        }
      } else if (today >= secondBeginDate && today <= thirdBeginDate) {
        // 구버전: 비번/생체 사용, app 업데이트 필수
        // 신버전: 비번/생체 사용 가능
        this.isAppUpdatedNeeded = !isNewVersion;
      } else if (today >= thirdBeginDate) {
        // 구버전: 비번/생체 사용, app 업데이트 필수
        // 신버전: 비번/생체 사용
        this.isAppUpdatedNeeded = !isNewVersion;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/cards/cardDetail.scss';
  @import '@/assets/styles/common/bottomButton.scss';
  @import '@/assets/styles/common/noticeBox.scss';
</style>
